import { AnswerContent as AnswerContentType, SkillApi } from './interface'
import { render } from './render'

const imgStyle = { maxWidth: '100%' }
export function renderAnswer(content: AnswerContentType, skillApi: SkillApi, cardId: string) {
  const t = render(content, skillApi, cardId)

  if (content.image) {
    return (
      <>
        {t}
        {!content.text ? null : <br />}
        <a href={content.image} target="_blank" rel="noopener noreferrer">
          <img src={content.image} alt={content.alt || ''} style={imgStyle} />
        </a>
      </>
    )
  }
  return t
}
